export default __webpack_public_path__ + "86f79a7785cabc7bfa1fbf68684f3d43.png";